import { __ } from '@wordpress/i18n';
import {Panel, PanelBody, PanelRow, TextControl,Button, TextareaControl, ToggleControl, RadioControl,ToolbarButton, ToolbarGroup} from "@wordpress/components"
import { Image, MediaToolbar } from "@10up/block-components"
import { useBlockProps, useBlockEditContext, BlockControls, InspectorControls, RichText, URLPopover} from "@wordpress/block-editor"
import { registerBlockType } from "@wordpress/blocks"
import apiFetch from '@wordpress/api-fetch';
import metadata from "./block.json"

/* import 'bootstrap/dist/css/bootstrap-grid.min.css'; */
import "./index.scss"

import React, { useRef, useState } from 'react';
// Import Swiper React components
import { Swiper as SwiperComponent, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';



// import required modules
import { Navigation } from 'swiper/modules';

registerBlockType(metadata.name, {...metadata, edit: EditComponent })


function EditComponent(props) {

  const {attributes, setAttributes}= props;
  const {icons, titulo, descricao, slides, subtituloCima, subtituloCimaLink, subtituloBaixo, subtituloBaixoLink} = attributes;

  const { clientId } = useBlockEditContext();


    const setIcon = (index, image) => {
      const newIcons = [...icons];
      newIcons[index] = { ...newIcons[index], id: image.id };
      setAttributes({ icons: newIcons });
    }

    const setIconUrl = (index, url) => {
      const newIcons = [...icons];
      newIcons[index] = { ...newIcons[index], url: url };
      setAttributes({ icons: newIcons });
    }

    const setIconTarget = (index, target) => {
      const newIcons = [...icons];
      newIcons[index] = { ...newIcons[index], target: target };
      setAttributes({ icons: newIcons });
    }
  
    const handleIconRemove = (index) => {
      const newIcons = [...icons];
      newIcons.splice(index, 1);
      setAttributes({ icons: newIcons });
      setSelectedIconIndex(null);
    }
  
    const addIcon = () => {
      const newIcons = [...icons, { id: null, url: "", target: "internal"}];
      setAttributes({ icons: newIcons });
      setSelectedIconIndex(newIcons.length - 1);
    }



    const moveIconsUp = (index) => {
      if (index === 0) return;
      const newIcons = [...icons];
      const temp = newIcons[index - 1];
      newIcons[index - 1] = newIcons[index];
      newIcons[index] = temp;
      setAttributes({ icons: newIcons });
      setSelectedIconIndex(index - 1);
      
    }
  
    const moveIconsDown = (index) => {
      if (index === icons.length - 1) return;
      const newIcons = [...icons];
      const temp = newIcons[index + 1];
      newIcons[index + 1] = newIcons[index];
      newIcons[index] = temp;
      setAttributes({ icons: newIcons });
      setSelectedIconIndex(index + 1);
    }





    const setSlideImage = (index, image) => {
      const newSlides = [...slides];
      newSlides[index] = { ...newSlides[index], id: image.id };
      setAttributes({ slides: newSlides });
    };

    const setSlideTitle = (index, title) => {
      const newSlides = [...slides];
      newSlides[index] = { ...newSlides[index], title: title };
      setAttributes({ slides: newSlides });
    };

    const setSlideDescription = (index, description) => {
      const newSlides = [...slides];
      newSlides[index] = { ...newSlides[index], description: description };
      setAttributes({ slides: newSlides });
    };

    const setSlideButtonText = (index, button_text) => {
      const newSlides = [...slides];
      newSlides[index] = { ...newSlides[index], button_text: button_text };
      setAttributes({ slides: newSlides });
    };

    const setSlideButtonURL = (index, button_url) => {
      const newSlides = [...slides];
      newSlides[index] = { ...newSlides[index], button_url: button_url};
      setAttributes({ slides: newSlides });
    };

    const setSlideTarget = (index, target) => {
      const newSlides = [...slides];
      newSlides[index] = { ...newSlides[index], target: target};
      setAttributes({ slides: newSlides });
    };
  
  
    const addSlide = () => {
      const newSlides = [...slides, { id: null, title: "", description: "", button_text: "", button_url:"", target: "internal" }];
      setAttributes({ slides: newSlides });
      setTimeout(() => {
        swiperRef.current.swiper.slideTo(newSlides.length - 1);
      }, 100); 
      setSelectedSlideIndex(newSlides.length - 1);
    }



    const moveSlidesLeft = (index) => {
      if (index === 0) return;
      const newSlides = [...slides];
      const temp = newSlides[index - 1];
      newSlides[index - 1] = newSlides[index];
      newSlides[index] = temp;
      setAttributes({ slides: newSlides });
    }
  
    const moveSlidesRight = (index) => {
      if (index === slides.length - 1) return;
      const newSlides = [...slides];
      const temp = newSlides[index + 1];
      newSlides[index + 1] = newSlides[index];
      newSlides[index] = temp;
      setAttributes({ slides: newSlides });
    }


    const handleSlideRemove = (index) => {
      const newSlides = [...slides];
      newSlides.splice(index, 1);
      setAttributes({ slides: newSlides });
    }

    const handlePanelBodyIconsAndSlide = (index) => {
      setSelectedSlideIndex(index);
      setSelectedIconIndex(null);
    }

    const handlePanelBodyIconAndSlides = (index) => {
      setSelectedIconIndex(index);
      setSelectedSlideIndex(null);
    }



    const [selectedIconIndex, setSelectedIconIndex] = useState(null);
    const [selectedSlideIndex, setSelectedSlideIndex] = useState(null);
    const [isEditing, setIsEditing] = useState(false);
    const swiperRef = useRef(null);
    const [currentIndex, setCurrentIndex] = useState(null);
    const [postLinks, setPostLinks] = useState([]);
    const [pageLinks, setPageLinks] = useState([]);
    const [formacoesLinks, setFormacoesLinks] = useState([]);
    const [isURLPopoverVisible, setURLPopoverVisible] = useState(false);
    const [selectedURL, setSelectedURL] = useState('');

    const openURLPopover = (index) => {
      setCurrentIndex(index);
      setSelectedURL(slides[index].button_url || '');
      setURLPopoverVisible(true);
    
      // Fetch post and page links when the popover is opened
      const fetchPosts = apiFetch({ path: '/wp/v2/posts?per_page=100' });
      const fetchPages = apiFetch({ path: '/wp/v2/pages?per_page=100' });
      const fetchFormacoes = apiFetch({ path: '/wp/v2/formacoes-posts?per_page=100' });
    
      Promise.all([fetchPosts, fetchPages, fetchFormacoes]).then(([posts, pages, formacoes]) => {
        const postLinks = posts.map(post => ({ id: post.id, title: post.title.rendered, link: post.link, type: 'post' }));
        const pageLinks = pages.map(page => ({ id: page.id, title: page.title.rendered, link: page.link, type: 'page' }));
        const formacoesLinks = formacoes.map(formacoes => ({ id: formacoes.id, title: formacoes.title.rendered, link: formacoes.link, type: 'formacoes-posts' }));
        setPostLinks(postLinks);
        setPageLinks(pageLinks);
        setFormacoesLinks(formacoesLinks);
      });
    };


    const saveURLSlideBotao = () => {
      setSlideButtonURL(currentIndex, selectedURL);
      setURLPopoverVisible(false);
    };


  return (
  <>
    <div id="parent" {...useBlockProps()}>

      <div class="container-fluid intro px-0">
          <div class="row align-items-center mx-0 g-0">
              <div class="col-lg-5 offset-lg-1">
                  <div class="row intro-content g-0">
                      <div class="col-lg-2">
                        {/* <Button className="components-button editor-document-tools__inserter-toggle is-primary has-icon" onClick={addIcon}>
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" aria-hidden="true" focusable="false"><path d="M11 12.5V17.5H12.5V12.5H17.5V11H12.5V6H11V11H6V12.5H11Z"></path></svg>
                        </Button> */}
                        <ul class="nav flex-column social-media">
                          {/* {icons.map((icon, index) => (
                            icon.id == null ? null : (
                              <li class="nav-item">
                                  <Image
                                    key={index}
                                    id={icon.id}
                                    size="full"
                                    onClick={() => handlePanelBodyIconAndSlides(index)}
                                  />
                              </li>
                            )
                          ))} */}

                          Edite os icons em Opções - Redes Sociais

                        </ul>
                          

                          {/* <InspectorControls>
                            <PanelBody title={('Definições do Icon')} initialOpen={true}>
                              {selectedIconIndex !== null && selectedIconIndex < icons.length && (
                                <>
                                  <Image
                                    id={icons[selectedIconIndex].id}
                                    size="full" 
                                    onSelect={(image) => setIcon(selectedIconIndex, image)}/>
                                    <br></br><br></br>
                                  <TextControl
                                    label={('Icon URL')}
                                    value={icons[selectedIconIndex].url}
                                    onChange={(url) => setIconUrl(selectedIconIndex, url)}
                                  />
                                  <ToggleControl
                                    label="Link Externo"
                                    checked={icons[selectedIconIndex].target === 'external'}
                                    onChange={(checked) => setIconTarget(selectedIconIndex, checked ? 'external' : 'internal')}
                                  />
                                  <br></br>
                                  <h3>Alterar Posição do Icon</h3>
                                  <ToolbarButton
                                    icon="arrow-up-alt2"
                                    label={__('Move Up', 'text-domain')}
                                    onClick={() => moveIconsUp(selectedIconIndex)}
                                    disabled={selectedIconIndex === 0} />
                                  <ToolbarButton
                                    icon="arrow-down-alt2"
                                    label={__('Move Down', 'text-domain')}
                                    onClick={() => moveIconsDown(selectedIconIndex)}
                                    disabled={selectedIconIndex === icons.length - 1} />
                                    <Button
                                    isSecondary
                                    onClick={(image) => setIcon(selectedIconIndex, image)}
                                  >
                                    Alterar Icon
                                  </Button>
                                  <Button
                                    isDestructive
                                    onClick={() => handleIconRemove(selectedIconIndex)}
                                  >
                                    Remover Icon
                                  </Button>
                                </>
                              )}
                            </PanelBody>
                          </InspectorControls> */}



                          <div class="button-scroll-down mt-5">
                              <a class="scroll-link" href="#main">
                                  <div class="scroll-text">
                                      <span>Scroll</span> 
                                  </div>
                                  <div class="scroll-icon">
                                      <span>
                                          <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor">
                                              <path d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z"></path>
                                          </svg>
                                      </span> 
                                  </div>
                              </a>
                          </div>
                      </div>
                      <div class="col-lg-8">
                          <div class="subtitle-bar">
                              <span class="subtitle">
                                  <span class="subtitle-icon text-primary">
                                      <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16">
                                          <path d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z"> </path>
                                      </svg>
                                  </span>
                                  <RichText
                                  value={ subtituloCima }
                                  onChange={(e) => setAttributes({ subtituloCima: e })}
                                  placeholder="Digite o subtitulo aqui..." />
                              </span>
                          </div>
                          <h1 class="mb-4">
                            <TextControl
                                  placeholder='Título'
                                  value={ titulo }
                                  onChange={(e) => setAttributes({ titulo: e })} />
                          </h1>
                          <p class="desciption">
                            <RichText
                                  value={ descricao }
                                  onChange={(e) => setAttributes({ descricao: e })}
                                  placeholder="Digite a descrição aqui..." />
                          </p>
                          <div class="subtitle-bar">
                              <span class="subtitle">
                                  <span class="subtitle-icon text-primary">
                                      <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16">
                                          <path d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z"> </path>
                                      </svg>
                                  </span>
                                  <TextControl
                                        value={ subtituloBaixo }
                                        onChange={(e) => setAttributes({ subtituloBaixo: e })}
                                        placeholder="Digite aqui..." />
                                  <TextControl
                                        value={ subtituloBaixoLink }
                                        onChange={(e) => setAttributes({ subtituloBaixoLink: e })}
                                        placeholder="Link..." />
                              </span>
                          </div>
                      </div>
                  </div>
              </div>
              <div class="col-lg-6 pe-lg-0">
                  <section>
                      <SwiperComponent
                        navigation={true}
                        modules={[Navigation]}
                        className="mySwiper"
                        ref={swiperRef}>
                          {slides.map((slide, index) => (
                            <SwiperSlide>
                              <Button isPrimary onClick={() => handlePanelBodyIconsAndSlide(index)}>Editar Slide</Button>
                              <div class="swiper-slide">  
                                <div class="bg-overlay"></div>
                                  {slide.id ? (
                                    <Image
                                      id={slide.id}
                                    />
                                  ) : null}
                                  <div class="swiper-content">
                                    <h3 class="title mb-4">
                                        <RichText
                                          value={ slide.title }
                                          onChange={(e) => setSlideTitle(index, e)}
                                          placeholder="Digite o título do slide aqui..." />
                                    </h3>
                                    <p class="description">
                                      <RichText
                                        value={ slide.description }
                                        onChange={(e) => setSlideDescription(index, e)}
                                        placeholder="Digite a descrição do slide aqui..." />
                                    </p>
                                    
                                    
                                    {slide.id ? (
                                      <Button className='btn btn-primary mt-4'>
                                        {slide.button_text || 'Edit Text'}
                                      </Button>
                                    ) : null}
                                    
                                    
                                    
                                  </div>
                                </div>                        
                            </SwiperSlide>
                          ))}
                      </SwiperComponent>


                      <Button isPrimary onClick={addSlide}>Adicionar Slide</Button>




                      {selectedSlideIndex !== null && selectedSlideIndex < slides.length && (
                          <InspectorControls>
                              <PanelBody title={('Definições do Slide')} initialOpen={true}>
                                <>
                                  <Image
                                    id={slides[selectedSlideIndex].id}
                                    size="full" 
                                    onSelect={(image) => setSlideImage(selectedSlideIndex, image)}/>
                                    <br></br><br></br>
                                  <Button
                                  isSecondary
                                  onClick={(image) => setSlideImage(selectedSlideIndex, image)}
                                  >
                                    Alterar Imagem
                                  </Button>
                                  <Button
                                    isDestructive
                                    onClick={() => handleSlideRemove(selectedSlideIndex)}
                                  >
                                    Remover Slide
                                  </Button>
                                  <br></br><br></br>
                                  <h3>Alterar Posição do Slide</h3>
                                  <ToolbarGroup>
                                    <ToolbarButton
                                    icon="arrow-left-alt2"
                                    label={__('Move Up', 'text-domain')}
                                    onClick={() => moveSlidesLeft(selectedSlideIndex)}
                                    disabled={selectedSlideIndex === 0} />
                                  <ToolbarButton
                                    icon="arrow-right-alt2"
                                    label={__('Move Down', 'text-domain')}
                                    onClick={() => moveSlidesRight(selectedSlideIndex)}
                                    disabled={selectedSlideIndex === slides.length - 1} />
                                  </ToolbarGroup>
                                  <br></br><br></br>
                                  <TextControl
                                    label={('Texto do Botão')}
                                    value={slides[selectedSlideIndex].button_text}
                                    onChange={(e) => setSlideButtonText(selectedSlideIndex, e)}
                                  />
                                  {/* <TextControl
                                    label={('Link do Botão')}
                                    value={slides[selectedSlideIndex].button_url}
                                    onChange={(url) => setSlideButtonURL(selectedSlideIndex, url)}
                                  /> */}
                                  <Button onClick={() => openURLPopover(selectedSlideIndex)} className='is-secondary mb-3'>
                                    { __('Alterar Ligação') }
                                  </Button>
                                  <ToggleControl
                                    label="Link Externo"
                                    checked={slides[selectedSlideIndex].target === 'external'}
                                    onChange={(checked) => setSlideTarget(selectedSlideIndex, checked ? 'external' : 'internal')}
                                  />
                                </>
                              </PanelBody>
                          </InspectorControls>
                      )}
                  </section>

                  {isURLPopoverVisible && (
                    <URLPopover onClose={() => setURLPopoverVisible(false)}>
                      <div style={{ padding: '8px' }}>
                        <TextControl
                          label={ __('URL') }
                          value={ selectedURL }
                          onChange={(url) => setSelectedURL(url)}
                        />
                        <h4>{__('Pages', 'text-domain')}</h4>
                        <ul>
                          {pageLinks.map((page) => (
                            <li key={page.id}>
                              <Button isLink onClick={() => setSelectedURL(page.link)}>
                                {page.title}
                              </Button>
                            </li>
                          ))}
                        </ul>
                        <br></br>
                        <h4>{__('Notícias', 'text-domain')}</h4>
                        <ul>
                          {postLinks.map((post) => (
                            <li key={post.id}>
                              <Button isLink onClick={() => setSelectedURL(post.link)}>
                                {post.title}
                              </Button>
                            </li>
                          ))}
                        </ul>
                        <br></br>
                        <h4>{__('Formações', 'text-domain')}</h4>
                        <ul>
                          {formacoesLinks.map((formacoes) => (
                            <li key={formacoes.id}>
                              <Button isLink onClick={() => setSelectedURL(formacoes.link)}>
                                {formacoes.title}
                              </Button>
                            </li>
                          ))}
                        </ul>
                        <Button isPrimary onClick={saveURLSlideBotao}>
                          { __('Save') }
                        </Button>
                      </div>
                    </URLPopover>
                  )}
            </div>
        </div>
      </div>
    </div>       
  </>
  )
}
